import KioskEditSetup from './KioskEditSetUp'

export default KioskEditSetup
